export const STATIC_NONCE = '9acf90b0-cf9d-4973-a4db-b279241ef13e'

export function getNonce(): string {
  const metaByProperty = document.querySelector(
    'meta[property="csp-nonce"]'
  ) as HTMLMetaElement | null
  const metaByName = document.querySelector(
    'meta[name="csp-nonce"]'
  ) as HTMLMetaElement | null
  return metaByProperty?.content || metaByName?.content || STATIC_NONCE
}
